import { render, staticRenderFns } from "./MhIcon.vue?vue&type=template&id=31e020d8"
import script from "./MhIcon.vue?vue&type=script&lang=js"
export * from "./MhIcon.vue?vue&type=script&lang=js"
import style0 from "./MhIcon.vue?vue&type=style&index=0&id=31e020d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports